import React, { useState, useEffect } from "react";
import { FaEye } from "react-icons/fa";
import { toast } from "react-toastify";

import {
  createPartnerRequest,
  getAllPartnerRequests,
  approvePartnerRequest,
} from "../../services/partnerRequest";

const PartnerRequest = () => {
  const [requests, setRequests] = useState([]);

  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    address: "",
    pincode: "",
  });

  // FETCH ALL PARTNER REQUESTS
  useEffect(() => {
    fetchPartnerRequests();
  }, []);

  const fetchPartnerRequests = async () => {
    try {
      const response = await getAllPartnerRequests();

      console.log("Partner Requests:", response);

      // inside fetchPartnerRequests()

      if (response?.status === 200) {
        const formattedData = response.data.map((item) => ({
          id: item.id || item.partner_id || item.request_id,

          name: item.name,
          email: item.email,
          mobile: item.mobile,
          address: item.address,
          pincode: item.pincode,

          apiStatus: String(item.status),

          status: String(item.status) === "1" ? "Read" : "Pending",
          created_at: item.created_at,
        }));

        setRequests(formattedData);
      }
    } catch (error) {
      console.log(error);

      toast.error(
        error?.message ||
        "Failed to fetch partner requests"
      );
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  // CREATE PARTNER REQUEST
  const handleSubmit = async () => {
    if (
      !form.name ||
      !form.email ||
      !form.mobile ||
      !form.address ||
      !form.pincode
    ) {
      toast.warning("All fields are required");
      return;
    }

    try {
      const payload = {
        name: form.name,
        email: form.email,
        mobile: form.mobile,
        address: form.address,
        pincode: form.pincode,
      };

      const response =
        await createPartnerRequest(payload);

      console.log("Create Response:", response);

      if (response?.status === 200) {
        toast.success(
          response.message ||
          "Partner request created successfully"
        );

        fetchPartnerRequests();

        setForm({
          name: "",
          email: "",
          mobile: "",
          address: "",
          pincode: "",
        });
      } else {
        toast.error(
          response?.error ||
          response?.message ||
          "Something went wrong"
        );
      }
    } catch (error) {
      console.log(error);

      toast.error(
        error?.error ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  // APPROVE PARTNER REQUEST
  const handleToggleStatus = async (item) => {
    try {
      console.log("FULL ITEM:", item);
      console.log("ID SENT TO API:", item.id);

      const response = await approvePartnerRequest(item.id);

      console.log("Approve Response:", response);

      if (response?.status === 200) {
        toast.success(
          response.message || "Partner approved successfully"
        );

        // IMPORTANT → refresh UI
        fetchPartnerRequests();
      } else {
        toast.error(
          response?.message || "Something went wrong"
        );
      }
    } catch (error) {
      console.log(error);

      toast.error(
        error?.message || "Something went wrong"
      );
    }
  };
  const formatDate = (dateString) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };
  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <h2 style={styles.heading}>
          Partner Requests
        </h2>
      </div>

      {/* Table */}
      <div style={styles.card}>
        <table style={styles.table}>
          <thead>
            <tr style={styles.theadRow}>
              <th>Date</th>
              <th>Name</th>
              <th>Email</th>
              <th>Mobile No.</th>
              <th>Address</th>
              <th>Pincode</th>
              <th
                style={{
                  textAlign: "center",
                }}
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {requests.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data-cell">
                  No Partner Requests Found
                </td>
              </tr>
            ) : (
              requests.map((item) => (
                <tr
                  key={item.id}
                  style={{
                    ...styles.row,
                    background:
                      item.apiStatus === "0"
                        ? "#ffe5e5"
                        : "#fff",
                  }}
                >
                  <td>{formatDate(item.created_at)}</td>
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.mobile}</td>
                  <td>{item.address}</td>
                  <td>{item.pincode}</td>

                  {/* Action */}
                  <td style={styles.actionCell}>
                    <button
                      style={{
                        ...styles.iconBtn,
                        opacity: item.apiStatus === "1" ? 0.5 : 1,
                        cursor: item.apiStatus === "1" ? "not-allowed" : "pointer",
                      }}
                      disabled={item.apiStatus === "1"}
                      onClick={() => handleToggleStatus(item)}
                    >
                      <FaEye
                        color={item.apiStatus === "1" ? "#1ab394" : "#f0ad4e"}
                      />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PartnerRequest;

const styles = {
  container: { padding: "10px" },

  header: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px",
  },

  heading: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#2f4050",
  },

  card: {
    background: "#fff",
    borderRadius: "10px",
    padding: "15px",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  theadRow: {
    background: "#f5f7fa",
  },

  row: {
    borderBottom: "1px solid #eee",
  },

  empty: {
    textAlign: "center",
    padding: "20px",
    color: "red",
    fontWeight: "500",
  },

  actionCell: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
  },

  iconBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
  },
};